import { PlusIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ADVISORACTIONS } from "../../../store/actions/advisorActions";
import MemberRow from "./MemberRow";
import NewTeamMemberModal from "./NewTeamMemberModal";

const AdvisorTeam = ({
	getAdvisorTeamMembers,
	advisorTeam,
	advisorId,
	userId,
	setInviteAdvisorModalStatus,
	isOwner,
	isAdmin,
}) => {
	useEffect(() => {
		if (advisorId) getAdvisorTeamMembers(advisorId);
	}, [advisorId]);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Team</h1>
						</div>
						{(isOwner || isAdmin) && (
							<div
								className="btn btn-success pull-right"
								style={{ marginLeft: 10 }}
								onClick={() => setInviteAdvisorModalStatus(true)}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Add New Team Member</div>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="content">
				<div className="block-header">
					<h3 className="block-title">Team Members</h3>
				</div>
				<div className="block-content">
					<div style={{ overflow: "scroll" }}>
						<table
							id="table-timesheets"
							className="table-responsive table table-hover"
						>
							<thead>
								<tr>
									<th>Name</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								{advisorTeam?.map((member) => (
									<MemberRow
										key={member.userId}
										member={member}
										canDeleteOthers={(isAdmin || isOwner) && member.userId !== userId}
										advisorId={advisorId}
									/>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<NewTeamMemberModal advisorId={advisorId} />
		</>
	);
};

const mapStateToProps = (state) => {
	const advisorTeam = state.advisors.team || [];
	const { id: userId, advisorId } = state.my.profile;
	const isOwner = advisorTeam.find((a) => a.userId === userId)?.status === "Owner";
	return {
		advisorTeam,
		advisorId,
		userId,
		isOwner,
		isAdmin: state.my?.profile?.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setInviteAdvisorModalStatus: (status) => dispatch(ADVISORACTIONS.inviteAdvisorModal(status)),
	getAdvisorTeamMembers: (advisorId) => dispatch(ADVISORACTIONS.getAdvisorTeamMembers(advisorId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorTeam);
